export default __webpack_public_path__ + "static/media/products_211.ea5b1149.jpg";